export default "__VITE_ASSET__yQauyW5T__"